import { premiumRequest } from "../../services/Premium";

export default async function saveOrderDraft(
  token,
  order,
  draft = order.draft,
) {
  if (!order.editableFields)
    throw new Error("Brak kontraktu edycji. Odśwież aplikację.");
  const result = await premiumRequest(token, `/orders/${order.id}`, {
    method: "PUT",
    data: {
      revision: order.revision,
      draft: Object.fromEntries(
        order.editableFields.map((key) => [key, draft[key]]),
      ),
    },
  });
  return result.order;
}
